import { render, staticRenderFns } from "./Reporting.vue?vue&type=template&id=6afa8520"
import script from "./Reporting.vue?vue&type=script&lang=js"
export * from "./Reporting.vue?vue&type=script&lang=js"
import style0 from "./Reporting.vue?vue&type=style&index=0&id=6afa8520&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports